/**
 * @generated SignedSource<<d6fa198a75210b1af6578c2ef765cbc3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type RsvpState = "ATTENDING" | "DECLINED" | "MAYBE" | "NOT_RESPONDED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EventCard_event$data = {
  readonly coverImage: {
    readonly url: URIString;
  } | null;
  readonly currentInvitation: {
    readonly id: string;
    readonly invitee: {
      readonly id: string;
    };
    readonly rsvp: RsvpState;
  } | null;
  readonly end: {
    readonly date: DateString ;
    readonly time: TimeOfDayString;
  } | null;
  readonly id: string;
  readonly name: string;
  readonly space: {
    readonly color: {
      readonly dark: string;
      readonly light: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"SpaceContextCard_space">;
  };
  readonly start: {
    readonly date: DateString ;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"DateTimeLabel_event" | "InviteeOverview" | "ItemMenu_node">;
  readonly " $fragmentType": "EventCard_event";
};
export type EventCard_event$key = {
  readonly " $data"?: EventCard_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventCard_event">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventCard_event",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DateTimeLabel_event"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SpaceContextCard_space"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Color",
          "kind": "LinkedField",
          "name": "color",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "light",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dark",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DateTime",
      "kind": "LinkedField",
      "name": "start",
      "plural": false,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DateTime",
      "kind": "LinkedField",
      "name": "end",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "time",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventInvitation",
      "kind": "LinkedField",
      "name": "currentInvitation",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rsvp",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Member",
          "kind": "LinkedField",
          "name": "invitee",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InviteeOverview"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CoverImage",
      "kind": "LinkedField",
      "name": "coverImage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ItemMenu_node"
        }
      ],
      "type": "Node",
      "abstractKey": "__isNode"
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "3d3fb2a8edd8433fcd5f94094b5684d8";

export default node;
